<template>
    <div class="resetPassword">
        <div class="resetPassword-form" @keyup.enter="putMemberPassword()">
            <lgn-form-item label-position="left">
                <div slot="label">原密碼</div>
                <lgn-input slot="input" type="password" class="admin-user__edit-dialog__body-edit-email" placeholder="請輸入原密碼" v-model="oldPassword"></lgn-input>
            </lgn-form-item>
            <lgn-form-item label-position="left">
                <div slot="label">新密碼</div>
                <lgn-input slot="input" type="password" class="admin-user__edit-dialog__body-edit-name" placeholder="最少 8 個字碼, 須包含英文及數字" v-model="newPassword"></lgn-input>
            </lgn-form-item>
            <div class="resetPassword-form-submit">
                <el-button class="resetPassword-form-submit-button main-button" @click="putMemberPassword()">送出</el-button>
            </div>
        </div>
    </div>
</template>
<script>
import lgnInput from '@/lgnComponents/lgnInput/lgnInput.vue'
import lgnFormItem from '@/lgnComponents/lgnForm/lgnFormItem.vue'
import * as api from "@/script/apiService/api.js"
export default {
    name: "resetPassword",
    data(){
        return{
            oldPassword: "",
            newPassword: ""
        }
    },
    components: {
        lgnInput,
        lgnFormItem
    },
    methods: {
        async putMemberPassword(){
            let vm = this;
            if(this.oldPassword.trim().length == 0 || this.newPassword.trim() == 0){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "密碼不得為空!"
                })
                return false
            }
            let res = await api.putMemberPassword(this.oldPassword, this.newPassword);
            if(!res.error_status){
                this.$message.success({
                    duration: 2500,
                    showClose: true,
                    message: "已成功更改密碼, 請重新登入",
                    onClose: function(){
                        vm.$store.commit({
                            type: "setUserInfo",
                            userInfo: null
                        })
                        vm.$router.push(`${process.env.VUE_APP_PACACLOUND_ROOT}/login`);
                    }
                })
            } else if(res.error_status == '400'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "請確認輸入的內容!"
                })
            } else if(res.error_status != '401' && res.error_status != '504'){
                this.$message.error({
                    duration: 2500,
                    showClose: true,
                    message: "發生錯誤!"
                })
            }
        }
    }
}
</script>